<template>
    <div class="wrap-tabs">
        <div class="wrap-tabs__content tab-rule">
            <div v-for="(item, index) in eventWorldcupInfo.listInfoRule" :key="index" class="tab-rule__item">
                <div class="icon">
                    <img :src="item.icon" loading="lazy" alt="icon"/>
                </div>
                <ul class="content">
                    <li v-for="(i, inx) in item.content" :key="inx" v-html="i.text" />
                </ul>
            </div>
        </div>
    </div>
</template>
<script>
import { eventWorldcupInfo } from '@/resources/worldcup/worldcup';

export default {
    data() {
        return {
            eventWorldcupInfo
        };
    }
};
</script>
